import React, { useState } from "react"
import { Input, Container, Form, FormGroup, Alert } from "reactstrap"
import validateInput from "../../view/shared/validations/validateToken"
import { Trans, useLingui } from "@lingui/react"
import { toast } from "react-toastify"
import { t } from "@lingui/macro"
import { useHistory, NavLink } from "react-router-dom"
import "react-phone-number-input/style.css"
import PhoneInput from "react-phone-input-2"

import { backendAPI } from "../../store/api"

const SuccessMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="success" />
    </div>
  )
}

const ErrorMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="error" />
    </div>
  )
}

const VerifyCode = () => {
  const [phoneNumber, setPhoneNumber] = useState("")
  const [token, setToken] = useState("")
  const [errors, setErrors] = useState({})
  const [bounce, setBounce] = useState("")
  const history = useHistory()
  const { i18n } = useLingui()

  const notify = (msg) => toast.info(msg)

  const isValid = () => {
    const { errors: validationErrors, isValid: validationIsValid } =
      validateInput({
        token,
        phone_number: phoneNumber,
      })

    if (!validationIsValid) {
      setErrors(validationErrors)
    }

    return validationIsValid
  }

  const phoneValidate = (phone) => {
    if (phone === "+") {
      return ""
    } else {
      return phone
    }
  }

  const verifyToken = async (tokenValue, phoneNumberValue) => {
    const phone = phoneValidate("+" + phoneNumberValue)
    await backendAPI.post(`/verify-code/${tokenValue}/${phone}`)
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      verifyToken(token, phoneNumber)
        .then(() => {
          notify(<SuccessMessage />)
          history.push("/")
        })
        .catch((error) => {
          const { response } = error
          if (!response || !response.data) {
            return
          }
          setBounce(error.response.data.detail)
          notify(<ErrorMessage />)
        })
    } else {
      setPhoneNumber("")
      setToken("")
    }
  }

  const smscode = i18n._(t({ id: "SMS Code" }))
  const submit = i18n._(t({ id: "Submit" }))
  const login_email = i18n._(t({ id: "Phone number" }))

  const inputStyle = {
    flex: "10",
    fontFamily: "Fira Sans",
    height: "50px",
    width: "100%",
    fontSize: "20px",
  }

  const formStyle = {
    flex: "10",
    padding: "5px",
    fontFamily: "Fira Sans",
    fontSize: "20px",
    height: "50px",
    width: "100%",
  }

  return (
    <div>
      <Container>
        <Alert color="secondary" style={loadingStyle}>
          <Trans id="token.sent" />{" "}
          <i>
            <NavLink to="/PhoneVerify">
              <Trans id="resend.token" />
            </NavLink>
          </i>
        </Alert>

        <Form onSubmit={onSubmit}>
          {bounce && <div className="alert alert-danger">{bounce}</div>}
          <FormGroup
            style={{
              direction: "ltr",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span style={{ color: "red" }}>{errors.phone_number}</span>
            <PhoneInput
              country="ne"
              placeholder={login_email}
              inputStyle={inputStyle}
              style={loadingStyle}
              value={phoneNumber}
              onChange={(phone) => setPhoneNumber(phone)}
              onlyCountries={["rw", "ke", "ne", "dk", "se", "tz", "zm", "hn"]}
              limitMaxLength={true}
            />
          </FormGroup>
          <FormGroup>
            <span style={{ color: "red" }}>{errors.token}</span>
            <input
              type="number"
              name="token"
              placeholder={smscode}
              style={formStyle}
              value={token}
              onChange={(e) => setToken(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="submit"
              value={submit}
              name="submit"
              className="btn btn-primary"
              size="lg"
            />
          </FormGroup>
        </Form>
      </Container>
    </div>
  )
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "18px",
}
export default VerifyCode
